class DateTimeService {
  static formatDateString = (date, showtime = false, showseconds = false) => {
    if (!date) return date;

    if (!(date instanceof Date)) {
      date = new Date(date);
    }

    if (isNaN(date.getTime())) {
      return "";
    }

    const padToTwoDigits = (num) => num.toString().padStart(2, "0");

    const year = date.getFullYear();
    const month = "-" + padToTwoDigits(date.getMonth() + 1);
    const day = "-" + padToTwoDigits(date.getDate());
    const hours = " " + padToTwoDigits(date.getHours());
    const minutes = ":" + padToTwoDigits(date.getMinutes());
    const seconds = showseconds ? ":" + padToTwoDigits(date.getSeconds()) : "";

    return showtime
      ? `${year}${month}${day}${hours}${minutes}${seconds}`
      : `${year}${month}${day}`;
  };

  static areDatesEqual = (date1, date2) => {
    const roundToSecond = (date) => Math.floor(new Date(date).getTime() / 1000);
    return roundToSecond(date1) === roundToSecond(date2);
  };

  static toLocalISOString(date) {
    const pad = (n) => n.toString().padStart(2, "0");

    return (
      date.getFullYear() +
      "-" +
      pad(date.getMonth() + 1) +
      "-" +
      pad(date.getDate()) +
      "T" +
      pad(date.getHours()) +
      ":" +
      pad(date.getMinutes()) +
      ":" +
      pad(date.getSeconds())
    );
  }

  static extractTime(input, withSeconds = false) {
    const date = new Date(input);

    if (isNaN(date)) return "";

    const pad = (n) => n.toString().padStart(2, "0");

    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return withSeconds
      ? `${hours}:${minutes}:${seconds}`
      : `${hours}:${minutes}`;
  }
}
export default DateTimeService;
